import { useQuery } from 'react-query';
import { getJSON } from '../api/http';
import { endpoints } from '../api/endpoints';

interface IProfileData {
    type: string;
    name: string;
    services: object;
}

export interface IGponDetails {
    id: string;
    lserial: string;
    mac: string;
    description: string;
    historydate: string;
    blocked: string;
    status: string;
    rxpower: string;
    model_type: string;
    model_name: string;
    deactivereason: string;
    ProfileData: IProfileData;
    ports: object;
    services: object;
    protocol: string;
    wifi_essid: string;
    wifi_password: string;
}


export const restructureGponDetails = ({ ProfileData, ports, services, lserial, blocked, rxpower, model_type, model_name, deactivereason, historydate, mac, description, status, id, protocol, wifi_essid, wifi_password }: IGponDetails) => ({
    // type: ProfileData.type,
    // name: ProfileData.name,
    // availableServices: ProfileData.services,
    modelType: model_type,
    modelName: model_name,
    profileData: ProfileData,
    serialNumber: lserial,
    isBlocked: blocked,
    receiverPower: rxpower,
    deactivateReason: deactivereason,
    historyDate: historydate,
    wifiSsid: wifi_essid,
    wifiPassword: wifi_password,
    protocol,
    ports,
    services,
    macAddress: mac,
    description,
    status,
    id,
})


const getGponDetails = async (id: string) =>
    getJSON(endpoints.devices.gpon.details.replaceAll("{id}", id));

export const useGponDetails = (id: string) => {
    const { data, isLoading, error } = useQuery(
        'GponDetails' + id,
        () => getGponDetails(id),
        {
            staleTime: Infinity,
        }
    );

    return {
        isLoading,
        data: restructureGponDetails(data?.data || {}),
        error,
    };
};
